import authService from './authService';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

class CommunityBetsService {
  constructor() {
    this.baseUrl = API_URL;
  }

  async getCommunityBets(page = 1, ordering = 'likes') {
    const response = await fetch(`${this.baseUrl}/community-bets/?page=${page}&ordering=${ordering}`, {
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error('Erro ao carregar apostas da comunidade');
    }
    return response.json();
  }

  async getMyUploadStatus() {
    const response = await fetch(`${this.baseUrl}/community-bets/my-status/`, {
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error('Erro ao verificar limite de uploads');
    }
    return response.json();
  }

  async uploadCommunityBet(file) {
    const csrfToken = await authService.getCsrfToken();
    const formData = new FormData();
    formData.append('image', file);

    const response = await fetch(`${this.baseUrl}/community-bets/upload/`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'X-CSRFToken': csrfToken,
      },
      body: formData,
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Erro ao enviar imagem');
    }
    return data;
  }

  async updateStatus(id, status) {
    const csrfToken = await authService.getCsrfToken();
    const response = await fetch(`${this.baseUrl}/community-bets/${id}/status/`, {
      method: 'PATCH',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': csrfToken,
      },
      body: JSON.stringify({ status }),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Erro ao atualizar estado');
    }
    return data;
  }

  async toggleLike(id) {
    const csrfToken = await authService.getCsrfToken();
    const response = await fetch(`${this.baseUrl}/community-bets/${id}/like/`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'X-CSRFToken': csrfToken,
      },
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Erro ao dar like');
    }
    return data;
  }

  async deleteCommunityBet(id) {
    const csrfToken = await authService.getCsrfToken();
    const response = await fetch(`${this.baseUrl}/community-bets/${id}/`, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'X-CSRFToken': csrfToken,
      },
    });

    if (!response.ok) {
      throw new Error('Erro ao eliminar imagem');
    }
    return true;
  }
}

const communityBetsService = new CommunityBetsService();
export default communityBetsService;
